import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[scrollTracker]'
})
export class ScrollTrackerDirective {
    @Output() public scrolled = new EventEmitter<any>();

    @HostListener('scroll', ['$event'])
    public onScroll(event:any) {
        const tracker = event.target;
        let endReached = false;
        const limit = tracker.scrollHeight - tracker.clientHeight;

        if (event.target.scrollTop === limit) {
            endReached = true;
        }

        this.scrolled.emit({
            pos: event.target.scrollTop,
            endReached
        });
    }
}
